/* eslint-disable
    @typescript-eslint/no-this-alias,
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import _ from 'underscore';

import { Analytics } from '@trello/atlassian-analytics';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import { getKey, Key } from '@trello/keybindings';

import { l } from 'app/scripts/lib/localize';
import { Util } from 'app/scripts/lib/util';
import { templates } from 'app/scripts/views/internal/templates';
import { View } from 'app/scripts/views/internal/view';
import { SelectMemberOnCardView } from 'app/scripts/views/member/SelectMemberOnCardView';
import { PopoverMemberSearcherTemplate } from 'app/scripts/views/templates/PopoverMemberSearcherTemplate';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

interface ComposerMemberSelectorView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  $el: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  appendSubview: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  model: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  modelCache: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setTimeout: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  subview: any;
}

// @ts-expect-error TS(2707): Generic type 'View<TOptions, TModel>' requires bet... Remove this comment to see the full error message
class ComposerMemberSelectorView extends View {
  static initClass() {
    // @ts-expect-error TS(2339): Property 'viewTitleKey' does not exist on type 'Co... Remove this comment to see the full error message
    this.prototype.viewTitleKey = 'select members';

    // @ts-expect-error TS(2339): Property 'events' does not exist on type 'Composer... Remove this comment to see the full error message
    this.prototype.events = {
      'mouseenter .item': 'hoverMemberSelect',
      'click .item': 'addOrRemoveMember',
      keyup: 'keyupEvent',
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  populate(idMems: any, hideSearch: any) {
    this.data = {
      idMems:
        idMems != null
          ? idMems
          : _.pluck(
              this.model
                .getBoard()
                .memberList.filterDeactivated({ force: true }).models,
              'id',
            ),
    };

    return (this.data.showSearch = !(
      this.data.idMems.length <= 5 || hideSearch
    ));
  }

  render() {
    this.$el.html(templates.fill(PopoverMemberSearcherTemplate, this.data));

    this.fillMems(this.data.idMems);
    if ($('.js-filter-emoji', this.$el).length > 0) {
      this.setTimeout(() => {
        return $('.js-filter-emoji', this.$el).focus().select();
      }, 20);
    }
    if ($('.js-filter-members', this.$el).length > 0) {
      this.setTimeout(() => {
        return $('.js-filter-members', this.$el).focus().select();
      }, 20);
    }

    return this;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fillMems(idMems: any) {
    // eslint-disable-next-line @trello/enforce-variable-case
    const $list = $('.js-members-list', this.$el);

    $list.empty();

    for (const idMember of Array.from(idMems.slice(0, 5))) {
      const member = this.modelCache.get('Member', idMember);

      this.appendSubview(
        this.subview(SelectMemberOnCardView, member, { card: this.model }),
        $list,
      );
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filterAndFillMembers(term: any) {
    const idBoardMems = _.pluck(this.model.getBoard().memberList.models, 'id');
    const mems = Util.filterMembers(this.modelCache, term, idBoardMems);

    if (mems.length > 0) {
      this.fillMems(mems);
      const elem = $('.js-members-list .item:first', this.$el);
      Util.selectMenuItem($('.js-members-list', this.$el), '.item', elem);
    } else {
      $('.js-members-list', this.$el)
        .html('<li><p class="empty"></p></li>')
        .find('p')
        .text(l('no matched members'));
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  hoverMemberSelect(e: any) {
    const elem = $(e.target).closest('.item');
    return Util.selectMenuItem($('.js-members-list', this.$el), '.item', elem);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  keyupEvent(e: any) {
    const key = getKey(e);

    // @ts-expect-error TS(2345): Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
    if ([Key.Tab, Key.Enter].includes(key)) {
      stopPropagationAndPreventDefault(e);
      $('.js-members-list .item.selected:first .js-select-member', this.$el)
        .first()
        .click();
      return;
      // @ts-expect-error TS(2345): Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
    } else if ([Key.ArrowUp, Key.ArrowDown].includes(key)) {
      stopPropagationAndPreventDefault(e);
      Util.navMenuList($('.js-members-list', this.$el), '.item', key);
      return;
    } else {
      const filter = $('.js-filter-members', this.$el);
      // the filter input is showed conditionally, we can't assume it'll always be
      // there
      if (filter.length > 0) {
        // @ts-expect-error TS(2532): Object is possibly 'undefined'.
        const input = filter.val().trim().toLocaleLowerCase();
        this.filterAndFillMembers(input);
      }
      return;
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  addOrRemoveMember(e: any) {
    stopPropagationAndPreventDefault(e);
    const parent = $(e.target).closest('.item');
    parent.toggleClass('active');
    const idMember = parent.find('[idMember]').attr('idMember');

    if (this.model.toggle('idMembers', idMember)) {
      // GAS migration cleanup: this is likely dead code
      // https://bitbucket.org/trello/web/pull-requests/5317/
      Analytics.sendTrackEvent({
        action: 'added',
        actionSubject: 'member',
        source: 'cardComposerMemberSelectorInlineDialog',
        attributes: {
          addedTo: 'card',
        },
      });
    } else {
      // GAS migration cleanup: this is likely dead code
      // https://bitbucket.org/trello/web/pull-requests/5317/
      Analytics.sendTrackEvent({
        action: 'removed',
        actionSubject: 'member',
        source: 'cardComposerMemberSelectorInlineDialog',
        attributes: {
          removedFrom: 'card',
        },
      });
    }
  }
}

ComposerMemberSelectorView.initClass();
export { ComposerMemberSelectorView };
